


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';

import {
  QuotationsClient,
  IncreaseQuotationByPercentageCommand,
} from '@/data/web-api-client';

import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxEmailRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
    components: {
        DxPopup,
        DxToolbarItem,
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxLabel,
        DxScrollView,
        DxRequiredRule,
        DxEmailRule,
    },
})
export default class IncreaseByPercentagePopup extends Vue {
  private show: boolean = false;
  private saving: boolean = false;
  private formdata: IncreaseQuotationByPercentageCommand = new IncreaseQuotationByPercentageCommand ({
    id: '',
    percentage: 0,
  });

  @Prop({required: true})
  private id!: string;

  public async open() {
    this.formdata.id = this.id;
    this.show = true;
  }

  private async save() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
          notificationService.invalidForm();
          return;
      }

      this.saving = true;
      await (new QuotationsClient(undefined, this.$axios))
        .increaseByPercentage(this.formdata);
      notificationService.showSuccessMessage('opgeslagen');
      this.$emit('updated');
      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }
}
